import React from 'react';

import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';

type AvatarOverlayPosition = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

interface SlideListItemProps {
  index: number;
  previewUrl?: string;
  avatarPreviewUrl?: string;
  avatarPosition?: AvatarOverlayPosition;
  isSelected: boolean;
  onClick: () => void;
}

function getAvatarPositionClasses(position: AvatarOverlayPosition) {
  if (position === 'top-left') return 'left-8 top-8';
  if (position === 'top-right') return 'right-8 top-8';
  if (position === 'bottom-left') return 'left-8 bottom-8';
  return 'right-8 bottom-8';
}

export function SlideListItem({
  index,
  previewUrl,
  avatarPreviewUrl,
  avatarPosition = 'bottom-right',
  isSelected,
  onClick,
}: SlideListItemProps) {
  return (
    <Stack
      className={cn(
        'flex w-full items-start gap-8 text-start',
        isSelected ? 'bg-bg-primary' : 'bg-bg-secondary',
      )}
      onClick={onClick}>
      <Typography
        className="mt-16 min-w-[2rem] text-center"
        color="text-text-placeholder"
        variant="body-short-01">
        {index + 1}
      </Typography>
      <Stack
        className={cn(
          'aspect-video w-full overflow-hidden rounded-8 border-2 transition-colors',
          isSelected ? 'border-text-primary' : 'border-transparent',
        )}>
        <Image
          alt={`Slide ${index + 1}`}
          className="h-full w-full rounded-6 object-cover"
          height={103}
          quality={100}
          src={previewUrl}
          width={184}
        />
        {/* {avatarPreviewUrl ? (
          <Stack
            className={cn(
              'absolute z-10 h-[3.2rem] w-[3.2rem] overflow-hidden rounded-full border border-white bg-bg-primary',
              getAvatarPositionClasses(avatarPosition),
            )}>
            <Image
              alt="Avatar preview"
              className="h-full w-full object-cover"
              height={32}
              src={avatarPreviewUrl}
              width={32}
            />
          </Stack>
        ) : null} */}
      </Stack>
    </Stack>
  );
}
